import React, { useState, useEffect } from "react";
import { Input } from "./../../../Components/ui/input";

import { SendOtp, ValidatePasswordOtp, userResetPassword } from "./../../../api";
import ButtonLoader from "./../../../Components/Loader";
import { Button } from "./../../../Components/ui/button";
import { useSettings } from "./../../../hooks";

const OTPVerification = ({
  cssRequired = false,
  setOtpVerified,
  email,
  userName,
  ResetPassword = false,
  setOtpData,
}) => {
  const [otp, setOtp] = useState("");
  const [timeLeft, setTimeLeft] = useState(180);
  const [isResendActive, setIsResendActive] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [otpToken, setOtpToken] = useState("");
  const { passwordForm, setShowOTP, setErrors, setActiveTab, setPasswordForm } =
    useSettings();

  async function sendOtp() {
    try {
      const data = await SendOtp({ reason: "change_password" });
      setOtpToken(data?.data?.otpToken);
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  }

  useEffect(() => {
    sendOtp();
  }, []);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else {
      setIsResendActive(true);
    }
  }, [timeLeft]);

  const handleResend = () => {
    if (isResendActive) {
      setTimeLeft(180);
      sendOtp();
      setError("");
      setIsResendActive(false);
      setOtp("");
    }
  };
  const validateOtp = (otp) => {
    if (!otp) {
      return "OTP is required";
    }
    if (otp.length !== 6) {
      return "OTP must be 6 digits";
    }
    if (!/^\d+$/.test(otp)) {
      return "OTP must contain only numbers";
    }
    return "";
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError("");
    const validationError = validateOtp(otp);
    if (validationError) {
      setError(validationError);
      return;
    }

    setIsLoading(true);
    try {
      // The reset endpoint validates otp + otpToken itself, so the OTP is
      // not verified separately when resetting the password.
      const VerifyOtp = ResetPassword
        ? true
        : await ValidatePasswordOtp({
            reason: "change_password",
            otp,
            otpToken,
          });
      if (ResetPassword && VerifyOtp)
        try {
          await userResetPassword({
            username: userName,
            newPassword: passwordForm?.newPassword,
            oldPassword: passwordForm?.oldPassword,
            otp,
            otpToken,
            appName: "MCA",
          });

          setActiveTab("basic-details");
          setShowOTP(false);
          setPasswordForm({
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
        } catch (error) {
          if (/otp/i.test(error?.message || "")) {
            setError(error.message);
            if (error.message.toLowerCase().includes("expired")) {
              setTimeLeft(0);
              setIsResendActive(true);
            }
            return;
          }
          setShowOTP(false);
          setErrors((prev) => ({
            ...prev,
            oldPassword: error?.message,
          }));
        }

      if (VerifyOtp && setOtpVerified) {
        setOtpVerified(false);
        if (setOtpData) {
          setOtpData({ otp, otpToken });
        }
      }
    } catch (error) {
      setError(error?.message || "Failed to verify OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const formatTime = (seconds) => {
    // const mins = Math.floor(seconds / 60);
    const secs = seconds % 180;
    return `${secs} sec`;
  };

  return (
    <div className={`mt-10 mb-10 ${cssRequired ? "sm:w-1/2 xl:w-1/3" : ""}  `}>
      <h2 className="text-blackShade font-[400] font-geomanistBold text-[20px] leading-[28px]">
        Enter OTP to reset your password
      </h2>

      <p className="text-greyish  mt-3 mb-6">
        We have sent an OTP to your registered email id
      </p>

      <form onSubmit={handleVerify}>
        <div className="space-y-4">
          <div>
            <label className="block text-greyish mb-2">Please enter OTP</label>
            <Input
              type="text"
              placeholder="Enter 6-digit OTP"
              maxLength={6}
              value={otp}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setOtp(value);
                setError("");
              }}
              className={`w-full p-2 border rounded font-geomanistRegular text-[16px] leading-[24px] text-blackShade ${
                error ? "border-red-500" : ""
              }`}
              disabled={isLoading}
            />
            {error && <p className="text-red-500 mt-1">{error}</p>}
          </div>

          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-600">
              {parseInt(formatTime(timeLeft)) > 0
                ? `${formatTime(timeLeft)} left`
                : " "}{" "}
            </span>

            <button
              type="button"
              onClick={handleResend}
              className={`${
                isResendActive && !isLoading
                  ? "text-blue-600 cursor-pointer"
                  : "text-gray-400 cursor-not-allowed"
              }`}
              disabled={!isResendActive || isLoading}
            >
              Didn't get OTP? Resend
            </button>
          </div>

          <Button
            type="submit"
            disabled={isLoading || otp.length !== 6}
            className={`bg-blue-600 text-white py-2 px-6 rounded-md font-geomanistMedium hover:bg-blue-700 transition-colors w-32 disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {isLoading && <ButtonLoader className={"mr-2"} />} Verify OTP
          </Button>
        </div>
      </form>
    </div>
  );
};

export default OTPVerification;
